import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";

import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx, nullsafe } from "keautils";
import { validation, formfields } from "kea-react"; import { componentToRx } from "app/logic/rx";
import { fa } from "typed-font-awesome";

type Entity = models.TurnoDto;
type Column = kea.Grid2Column<Entity>;

/**Columnas fijas del grid */
const columnasFijas: Column[] = [
    { title: "Fecha de inicio", cell: x => ({ data: kea.toDate(x.FechaEntrada) }) },
    { title: "Fecha de finalización", cell: x => ({ data: kea.toDate(x.FechaSalida) }) },
    { title: "Usuario", cell: x => ({ data: x.NombreUsuario }) },
    { title: "Caja administrativa", cell: x => ({ data: x.NombreCajaAdministrativa }) },
    { title: "Sucursal", cell: x => ({ data: x.NombreSucursal }) },
    { title: "Caja de documentación", cell: x => ({ data: nullsafe(x.Cajas.Documentacion, x => x.Nombre) }) },
    { title: "Caja de entrega a domicilio", cell: x => ({ data: nullsafe(x.Cajas.EntregaDomicilio, x => x.Nombre) }) },
    { title: "Caja de entrega a ocurre", cell: x => ({ data: nullsafe(x.Cajas.EntregaOcurre, x => x.Nombre) }) },
    { title: "Caja de entrega zona extendida", cell: x => ({ data: nullsafe(x.Cajas.EntregaZE, x => x.Nombre) }) },
    { title: "Caja de cobranza", cell: x => ({ data: nullsafe(x.Cajas.Cobranza, x => x.Nombre) }) },
    { title: "Caja de facturación", cell: x => ({ data: nullsafe(x.Cajas.Facturacion, x => x.Nombre) }) },
    { title: "Caja de paquetes PP", cell: x => ({ data: nullsafe(x.Cajas.PaquetePP, x => x.Nombre) }) },
];

export interface BotonesListaDeps {
    onFinalizar: (x: Entity) => void;
    onVerCorte: (x: Entity) => void;
}

/**Obtiene las columnas del grid */
export function columnas(deps: BotonesListaDeps, permisos: models.Rol): Column[] {
    const botones = kea.columnaBotones([
        { onClick: deps.onFinalizar, tooltip: "Cerrar turno", iconClass: fa("close"), disabled: x => x.FechaSalida != null || !permisos.Turnos.VerFinalizarTurno },
        { onClick: deps.onVerCorte, tooltip: "Ver corte", iconClass: fa("gg"), disabled: x => !permisos.Turnos.VerCorteTurno },
    ]);
    return [botones, ...columnasFijas];
}


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/turnos/list/columns.tsx